module.exports = __webpack_public_path__ + "static/media/212-Sturz-Ansprechen-Teil2-Milo_ID_8.a90ae5cc.mp3";